"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRedux = require("react-redux");

var _developmentOnly = require("redux-devtools-extension/developmentOnly");

var _reducers = _interopRequireDefault(require("./reducers"));

require("./styles/fulfillmentconfigurationpicker.css");

var _i18n = _interopRequireDefault(require("./i18n/i18n"));

var _ComponentShellContainer = _interopRequireDefault(require("./componentshell/containers/ComponentShellContainer"));

/* eslint-disable complexity */
// eslint-disable-next-line no-unused-vars
var middleware = [_reduxThunk["default"]]; // Make sure irrelivant changes to the parent's state doesn't rerender the component and lose the redux state

var rerenderComparisonFunction = function rerenderComparisonFunction(prevProps, nextProps) {
  var previousAccessToken = prevProps.accessToken,
      previousLanguage = prevProps.language,
      previousEnvironment = prevProps.environment,
      previousBuyerAccountId = prevProps.buyerAccountId,
      previousProductConfigurationUrl = prevProps.productConfigurationUrl,
      previousInitialFulfillmentConfigurationUrl = prevProps.initialFulfillmentConfigurationUrl;
  var currentAccessToken = nextProps.accessToken,
      currentLanguage = nextProps.language,
      currentEnvironment = nextProps.environment,
      currentBuyerAccountId = nextProps.buyerAccountId,
      currentProductConfigurationUrl = nextProps.productConfigurationUrl,
      currentInitialFulfillmentConfigurationUrl = nextProps.initialFulfillmentConfigurationUrl;

  if (previousAccessToken !== currentAccessToken || previousLanguage !== currentLanguage || previousEnvironment !== currentEnvironment || previousBuyerAccountId !== currentBuyerAccountId || previousProductConfigurationUrl !== currentProductConfigurationUrl || previousInitialFulfillmentConfigurationUrl !== currentInitialFulfillmentConfigurationUrl) {
    return false;
  }

  return true;
};

var store = (0, _redux.createStore)((0, _redux.combineReducers)(_reducers["default"]), (0, _developmentOnly.composeWithDevTools)(_redux.applyMiddleware.apply(void 0, middleware)));

var FulfillmentConfigurationPicker = /*#__PURE__*/_react["default"].memo(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: store
  }, /*#__PURE__*/_react["default"].createElement(_ComponentShellContainer["default"], props));
}, rerenderComparisonFunction);

var _default = FulfillmentConfigurationPicker;
exports["default"] = _default;